import { render, staticRenderFns } from "./AccessPopup.vue?vue&type=template&id=785c5a53&scoped=true&"
import script from "./AccessPopup.vue?vue&type=script&lang=ts&"
export * from "./AccessPopup.vue?vue&type=script&lang=ts&"
import style0 from "./AccessPopup.vue?vue&type=style&index=0&id=785c5a53&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "785c5a53",
  null
  
)

export default component.exports